'use client';

import { useLocale } from 'next-intl';
import type { Labels } from 'react-phone-number-input';
import en from 'react-phone-number-input/locale/en.json';
import ar from 'react-phone-number-input/locale/ar.json';
import de from 'react-phone-number-input/locale/de.json';
import es from 'react-phone-number-input/locale/es.json';
import fr from 'react-phone-number-input/locale/fr.json';

const LABELS: Record<string, Labels> = {
    en,
    ar,
    de,
    es,
    fr
};

export function getPhoneLabels(locale: string): Labels {
    return LABELS[locale] ?? en;
}

export function usePhoneLabels(): Labels {
    const locale = useLocale();
    return getPhoneLabels(locale);
}
